import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    
    getAll,
    getGroupsForDropdown,
    getAllOperationEntitiesForDropDown,
    getCollectionPointByOperationEntityId,
    getTagAmendmentRequests,
    approve,
    getFactoryAmendmentRequest,
    approveFactory,
    reject
};

async function getTagAmendmentRequests(data){
    const response = await CommonPost('/api/TagAmendment/GetTagAmendRequest', null, data);

    return response.data;
}

async function getAll(){
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function getGroupsForDropdown() {
    var groupArray = [];
    
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }

    return groupArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionPointByOperationEntityId(operationEntityID) {
    var collectionPointArray = [];
  
    var response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + operationEntityID);
   
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }

    return collectionPointArray;
}

async function approve(data){
    const response = await CommonPost('/api/TagAmendment/ApproveTagAmendment', null, data);

    return response;
}


async function getFactoryAmendmentRequest(data){
    const response = await CommonPost('/api/TagAmendment/GetFactoryAmendmentRequestByTag', null, data);
    return response.data;
}

async function approveFactory(data){
    const response = await CommonPost('/api/TagAmendment/ApproveFactoryTagAmendment', null, data);
    return response;
}

async function reject(data){
    const response = await CommonPost('/api/TagAmendment/ChangeFeildTagAmentStatus', null, data);

    return response;
}

